module.exports = __webpack_public_path__ + "static/media/Tammy_Fisher_Rec.b2d58952.png";